module.exports = __webpack_public_path__ + "img/img15.1f601ca7.svg";